import { createContext, useContext } from "react";
export var AiTextAreaContext = createContext({
    existingLinkedFiles: [],
    fileReferences: [],
    setFileReferences: function () { },
});
export var useAiTextAreaContext = function () {
    return useContext(AiTextAreaContext);
};
